import { TItemCustomViewExtended } from 'components/CustomizeView/CustomizeView';

type SectionVariant =
  | 'streamingPerformance'
  | 'playlists'
  | 'dspCharts'
  | 'officialCharts'
  | 'radioPerformance'
  | 'shazam'
  | 'downloadPerformance'
  | 'physicalPerformance'
  | 'territory'
  | 'shortFormVideo'
  | 'socialPerformance';

type tType = TItemCustomViewExtended & {
  value: SectionVariant;
};

export interface ISectionComponent {
  [keyEl: string]: JSX.Element;
}

export const getSections = (entityType: string): tType[] => [
  {
    label: 'Streaming Performance',
    value: 'streamingPerformance',
  },
  ...(entityType === 'release'
    ? []
    : [
        {
          label: 'Playlists',
          value: 'playlists' as SectionVariant,
        },
      ]),
  {
    label: 'DSP Charts',
    value: 'dspCharts',
  },
  {
    label: 'Official Charts',
    value: 'officialCharts',
  },
  ...(entityType === 'release'
    ? []
    : [
        {
          label: 'Radio Performance',
          value: 'radioPerformance' as SectionVariant,
        },
      ]),
  ...(entityType === 'project' || entityType === 'release'
    ? []
    : [
        {
          label: 'Shazam',
          value: 'shazam' as SectionVariant,
        },
      ]),
  {
    label: 'Download Performance',
    value: 'downloadPerformance',
  },
  ...(entityType === 'track'
    ? []
    : [
        {
          label: 'Physical Performance',
          value: 'physicalPerformance' as SectionVariant,
        },
      ]),
  {
    label: 'Territory',
    value: 'territory',
  },
  ...(entityType === 'project' || entityType === 'release'
    ? []
    : [
        {
          label: 'Short Form Video',
          value: 'shortFormVideo' as SectionVariant,
        },
      ]),
  {
    label: 'Social Performance',
    value: 'socialPerformance',
  },
];
